import { DataBean } from "../DataBean";

export class SIIFAuxiliaryCatalog extends DataBean {


    public async getSIIFAuxiliaryCatalog(type:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getSIIFAuxiliaryCatalog_Number", [type]);
    }

 
}